<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import CheckModal from "@/components/CheckModal";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import Table from "@/components/standard/PromotionPrevention/components/PromotionTable";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import auditoriaAPI from "../../../services/standards/auditoria/auditoriaAPI";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "6.1.2 Auditoria anual del SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
  },
  data() {
    return {
      title: "6.1.2 Auditoria anual del SG SST",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "6.1.2 Auditoria anual del SG SST",
        },
        {
          text: "Ver",
          active: true,
        },
      ],
      list: [],
      usersList: [],

      item: null,

      itemData: null,
      search: "",

      lista: [],
      loading: true,

      file: null,
      file2: null,

      auditoria: {
        plan: null,
        report: null,
        business_audits_id: this.$route.params.id,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(54)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    getItems() {
      try {
        CompanyItemsAPI.getStatus(this.companyID, 54)
          .then((response) => {
            this.item = response || null;
          })
          .catch((error) => {
            this.item = null;
            console.log(error);
          });
      } catch (error) {
        this.item = null;
        console.log(error);
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesPromocion(response.id).then((res) => {
            this.usersList = res.employee;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getShow() {
      auditoriaAPI
        .getShowP(this.$route.params.id)
        .then((response) => {
          this.auditoria = {
            plan: response.data.plan,
            report: response.data.report,
            business_audits_id: response.data.business_audits_id,
            companies_id: response.data.companies_id,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },

  },
  mounted() {
    this.getItems();
    this.getItemData();
    this.getUsers();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />

              <form class="form-group">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-6 px-2 text-center" label="Cargar plan de auditoría" label-for="file">
                    <div v-if="auditoria.plan === null">
                      <h6>No hay archivo disponible</h6>
                    </div>
                    <div v-else class="d-flex justify-content-center">
                      <button :disabled="!allowAccess()" style="
                          background-color: transparent !important;
                          border: none;
                        " type="button" @click="gotoDigitalOcean(`${auditoria.plan}`)">
                        <i class="mdi mdi-cloud-download"></i>
                      </button>
                    </div>

                  </b-form-group>

                  <b-form-group class="col-md-6 px-2 text-center" label="Cargar informe de auditoría" label-for="file">
                    <div v-if="auditoria.report === null">
                      <h6>No hay archivo disponible</h6>
                    </div>
                    <div v-else class="d-flex justify-content-center">
                      <button :disabled="!allowAccess()" style="
                          background-color: transparent !important;
                          border: none;
                        " type="button" @click="gotoDigitalOcean(`${auditoria.report}`)">
                        <i class="mdi mdi-cloud-download"></i>
                      </button>
                    </div>

                  </b-form-group>
                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
